import { Component, OnInit, QueryList, ContentChildren, OnDestroy } from '@angular/core';
import { TopbarItemComponent } from './topbar-item/topbar-item.component';
import { AuthService } from 'src/app/auth/auth.service';
import { LocalStorageKeys } from 'src/app/shared/models/local-storage.model';
import { AlertService } from 'src/app/shared/services/alert.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html'
})
export class TopbarComponent implements OnInit, OnDestroy {
  @ContentChildren(TopbarItemComponent) items: QueryList<TopbarItemComponent>;

  constructor(private authService: AuthService, private alertService: AlertService) { }

  ngOnInit() {

  }

  logout() {
    this.authService.logout().subscribe();
  }

  ngOnDestroy() {

  }
}
